module.exports = __webpack_public_path__ + "static/media/delete.9f8f54f6.svg";